import { styled } from '@mui/system'
import { ClusterImage as ClusterImageBase, ClusterMarker as ClusterMarkerBase } from './store-locator.styled'

const shouldForwardProp = (prop) => !['minHeight'].includes(prop)

const InnerWrapper = styled('div', { shouldForwardProp })`
	height: 100%;
	display: flex;
	flex-direction: column;
	flex-basis: 100%;
	> div:last-of-type:not(:only-of-type) {
		margin-top: ${({ theme }) => theme.spacing(2)};
		height: 100%;
	}
	> div:only-of-type {
		.stores-list-wrapper {
			min-height: ${({ minHeight, theme }) =>
				minHeight ? `calc(${minHeight}px - ${theme.spacing(9 + 5)})` : 'unset'}; /* added */
		}
	}
`

const Root = styled('div')`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(4)};
	${({ theme }) => theme.breakpoints.up('lg')} {
		flex-direction: row-reverse;
		width: 100%;
		> div:first-of-type {
			width: 70%;
			min-width: 70%;
		}
		> div:last-of-type {
			width: 30%;
		}
	}
`

const ClusterImage = styled(ClusterImageBase)``

const ClusterMarker = styled(ClusterMarkerBase)``

export { ClusterImage, ClusterMarker, InnerWrapper, Root }
